import RequestAbsencesForm from "./requestAbsences";
import { Modal } from "../../../components/others/Modal/index";
import MapWrapper from "../../../components/others/MapWrapper/MapWrapper";

type TProps = {
  toggleModal: boolean;
  urlTittle: string;
  refreshFunction: Function
};

const RequestAbsences = ({ toggleModal, urlTittle, refreshFunction }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";
  return (
    <>
      <Modal
        show={toggleModal}
        modalTitle={"Solicitar un ausentismo"}
        titleStyle={styles} 
        urlTittle={urlTittle}
      >
        <MapWrapper>
          <RequestAbsencesForm refreshFunction={refreshFunction}/>
        </MapWrapper>
      </Modal>
    </>
  );
};

export default RequestAbsences;
